// core
import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {forkJoin} from 'rxjs';

// 3'rd party
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';

// model
// services
import {RolesService} from '../../../../role/roles.service';
import {AppConstants} from '../../../../utils/constants';

// utils
import {RolesUtils} from '../../../../utils/roles.utils';


@Component({
    selector: 'app-roles-modal',
    templateUrl: './roles-modal.component.html',
    styleUrls: ['./roles-modal.component.scss'],
    standalone: false
})
export class RolesModalComponent implements OnInit {

  public rolesForm: UntypedFormGroup;
  public listOfRoles;
  public preselectedTargetGroup;
  public preselectedRoles;
  public customerNumber;
  public currentFlow: string;
  public callBack;
  private data;
  public userId;

  private addUserFlow: string = AppConstants.CREATE_MODE;
  private editUserFlow: string = AppConstants.EDIT_MODE;

  constructor(public rolesModalRef: BsModalRef,
              private _formBuilder: UntypedFormBuilder,
              private _rolesService: RolesService,
              private _rolesUtils: RolesUtils) {
    this.rolesForm = this._formBuilder.group({
      roles: [
        {
          value: '',
          disabled: false
        }
      ]
    });
  }


  ngOnInit() {
    this.initializeRolesBasedOnFlow();
  }

  private initializeRolesBasedOnFlow(): void {
    if (this.currentFlow === this.editUserFlow) {
      this.handleEditUserFlow();
    } else if (this.customerNumber) {
      this.loadRolesForNewAssignedCustomer();
    } else if (this.preselectedTargetGroup) {
      this.loadRolesForNewAssignedTargetGroup();
    }
  }

  private handleEditUserFlow(): void {
    if (this.userId) {
      if (this.customerNumber) {
        // direct edit of roles with an assigned customer
        this.rolesForm.controls.roles.setValue(this.preselectedRoles);
      } else {
        // direct edit of roles without an assigned customer
        if(this.preselectedRoles) {
          this.loadRolesForEditByTargetGroup();
        }
        else {
          // assigned new tg to existing user
          this.loadRolesForNewAssignedTargetGroup();
        }
      }
    } else if (this.customerNumber) {
      // new customer assigned
      this.loadRolesForNewAssignedCustomer();
    }
    else if(this.preselectedTargetGroup) {
      // assigned new tg to existing user after deleting his customer
      this.loadRolesForNewAssignedTargetGroup();
    }
  }

  private loadRolesForEditByTargetGroup(): void {
    this._rolesService.getAssignableRolesForTargetGroup(this.preselectedTargetGroup).subscribe({
      next: (assignableRoles) => {
        this.listOfRoles = this._rolesUtils._prepareRolesSelection(assignableRoles);
        this.rolesForm.controls.roles.setValue(this.preselectedRoles);
      },
      error: (error) => {
        console.error('Error loading target group roles for edit:', error);
      }
    });
  }

  private loadRolesForNewAssignedCustomer(): void {
    this._rolesService.getAssignedCustomerRoles(this.customerNumber).subscribe({
      next: (customerRoles) => {
        this.listOfRoles = this._rolesUtils._prepareRolesSelection(customerRoles);
        this._setSelectedRoles(customerRoles);
      }
    });
  }

  private loadRolesForNewAssignedTargetGroup(): void {
    // Execute parallel requests for better performance
    const parallelRequests = {
      defaultRoles: this._rolesService.getDefaultRolesForTargetGroup(this.preselectedTargetGroup),
      assignableRoles: this._rolesService.getAssignableRolesForTargetGroup(this.preselectedTargetGroup)
    };

    forkJoin(parallelRequests).subscribe({
      next: (results) => {
        this.listOfRoles = this._rolesUtils._prepareRolesSelection(results.assignableRoles);
        this._setSelectedRoles(results.defaultRoles);
      },
      error: (error) => {
        console.error('Error loading roles for target group:', error);
      }
    });
  }


  public getAddUserFlow() {
    return this.addUserFlow;
  }

  public getEditUserFlow() {
    return this.editUserFlow;
  }

  public goToNextStep() {
    this.rolesModalRef.hide();
    this.data = {
      roles: this.rolesForm.controls['roles'].value,
      roleOptions: this.listOfRoles
    };
    this.callBack(AppConstants.rolesModal, this.data);
  }

  private _setSelectedRoles(roles: Array<any>) {
    if (roles) {
      const result: Array<string> = new Array<string>();
      roles.forEach(role => {
        result.push(role.id || role.roleId || role.value);
      });
      this.rolesForm.controls.roles.setValue(result);
    }
  }

}
